// Alphabet sans caractères ambigus (0/O, 1/l/I) : le mot de passe est communiqué à la main.
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789'

/** Mot de passe aléatoire (12 caractères par défaut ; l'API en exige 8 au minimum). */
export function generatePassword(length = 12) {
  const bytes = new Uint32Array(length)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, (n) => ALPHABET[n % ALPHABET.length]).join('')
}

/** Copie dans le presse-papiers ; renvoie false si le navigateur le refuse. */
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (e) {
    // Contexte non sécurisé (http sur le réseau local) : repli par sélection.
    const area = document.createElement('textarea')
    area.value = text
    area.style.position = 'fixed'
    area.style.opacity = '0'
    document.body.appendChild(area)
    area.select()
    let ok = false
    try {
      ok = document.execCommand('copy')
    } catch (err) {
      ok = false
    }
    area.remove()
    return ok
  }
}
